:host {
  display: block;


  /**
    * @prop --viewer-annotation-callout-primary-color: A CSS color that
    * specifies the primary color of the callout.
    */
    --viewer-annotation-callout-primary-color: var(--blue-700);

  /**
   * @prop --viewer-annotation-callout-accent-color: A CSS color that
   * specifies a contrasting color to the primary color.
   */
   --viewer-annotation-callout-accent-color: var(--white);
}

.content {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;

  background-color: var(--viewer-annotation-callout-primary-color);
  border: 1px solid var(--viewer-annotation-callout-accent-color);
}

.content.sm {
  border-radius: 14px;
  width: 28px;
  height: 28px;
}

.content.md {
  border-radius: 19px;
  width: 38px;
  height: 38px;
}

.content.lg {
  border-radius: 24px;
  width: 48px;
  height: 48px;
}

.icon {
  color: var(--viewer-annotation-callout-accent-color);
}